<template>
  <div :class="[section.static_section_id.split('_').join('-')]" class="promo">
    <div class="rs-container">
      <div class="wrapper banner-wrapper">
        <template v-if="section.static_section_id === 'broadcast_overlay_promo'">
          <div class="content-wrapper">
            <span class="badge">New</span>
            <h2 class="title">Introducing<br />Broadcast Overlay</h2>
            <p class="desc">
              A complete cricket broadcast overlay with live scorecards, player cards, and real-time match visuals.
              Includes 17+ views like charts, partnerships, bowling stats, fall of wickets, and key moments.
              Works with any browser source tool like OBS, vMix, Streamlabs, or StreamYard.
              Fully customizable or ready to use instantly.
            </p>
            <a class="cta-link" href="https://cal.com/supraja-raghuraman">Get Demo</a>
          </div>
          <div class="image-wrapper">
            <img class="overlay-img" src="@/assets/overlayImage.png" alt="Broadcast Overlay Preview" />
          </div>
        </template>
        <template v-else>
          <div class="content-wrapper">
            <h6 :class="[section.detail.links[1].element_class === 'text' ? '': 'flag-text']"
              v-if="section.detail.links && section.detail.links[1] && section.detail.links[1].name">
              {{section.detail.links[1].name}}</h6>
            <rz-markdown class="hero-title" v-if="section.detail.name"
              :text="section.detail.name"></rz-markdown>
            <rz-markdown v-if="section.detail.desc" class="text" :text="section.detail.desc"></rz-markdown>
            <TextButton :buttonType="'rs-button'" :key="section.detail.links[0].name"
              :link="section.detail.links[0]" />
          </div>
          <div class="image-wrapper">
            <rz-image-item class="banner-artwork"
              v-if="section.detail.img" :image="section.detail.img" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import TextButton from '@/components/RZWebsite/TextButton.vue';

export default {
  props: {
    section: Object,
  },
  components: {
    TextButton,
  },
};
</script>
<style lang="scss">
.banner-wrapper {
    .content-wrapper {
        .hero-title {
            display: inline-block;
            font-weight: 800;
            font-size: size(30);
            line-height: size(42);
            padding-bottom: size(10);
            padding-right: 0;
            color: #97E6AB;
            @media screen and (min-width: $breakpoint-md) {
                font-size: size(60);
                line-height: size(74);
            }
            strong {
                font-weight: bold;
                font-size: size(30);
                line-height: size(42);
                padding-right: 0;
                color: var(--rs-white-color);
                padding-bottom: 0;
                @media screen and (min-width: $breakpoint-md) {
                    font-size: size(60);
                    line-height: size(74);
                }
            }
        }
        .text {
            .p {
                font-size: size(16);
                line-height: size(24);
                color: var(--rs-white-color);
                padding-bottom: size(30);
            }
        }
        .text-button.rs-button .link {
            padding: 0;
            margin: 0;
            color: var(--rs-white-color);
            border: none;
            outline: none;
            &:after {
                border-color: var(--rs-white-color);
                margin-left: size(10);
            }
        }
    }
}
.betting-odds-promo {
    &.promo {
        .rs-container {
            padding-top: size(32);
            @media screen and (min-width: $breakpoint-md) {
                padding-bottom: 0;
            }
            .wrapper {
                background: #2D2F9D;
                border-radius: size(6);
                padding: size(30) size(20) 0;
                @media screen and (min-width: $breakpoint-md) {
                    padding: size(50) size(20) size(30);
                }
                @media screen and (min-width: size(1024)) {
                    padding-bottom: 0;
                }
                @media screen and (min-width: $breakpoint-lg) {
                    padding: size(60) size(60) 0;
                }
                .text-button.rs-button .link {
                    padding: 0;
                    margin: 0;
                    color: var(--rs-white-color);
                    border: none;
                    outline: none;
                    &:after {
                        border-color: var(--rs-white-color);
                        margin-left: size(10);
                    }
                }
                .content-wrapper {
                    @media screen and (min-width: size(1024)) {
                        padding-bottom: size(50);
                    }
                    @media screen and (min-width: $breakpoint-lg) {
                        padding-bottom: size(60);
                    }
                }
                .image-wrapper {
                    height: size(350);
                    @media screen and (min-width: $breakpoint-md) {
                        height: size(400);
                    }
                }
            }
        }
    }
}
.bbl-package-promo {
    &.promo {
        .rs-container {
            padding-top: size(32);

            @media screen and (min-width: $breakpoint-md) {
                padding-bottom: 0;
            }

            .banner-wrapper {
                padding: 0;
                @media screen and (max-width: $breakpoint-md) {
                    padding: 0;
                }
            }
            .content-wrapper {
                padding-left: 20px;
                padding-right: 20px;
                padding-top: 40px;
                padding-bottom: 40px;
                @media screen and (min-width: 1200px) {
                    padding-left: 60px;
                    padding-right: 60px;
                    padding-top: 60px;
                    padding-bottom: 60px;
                }
                @media screen and (max-width: 425px) {
                    padding-bottom: 0px;
                    padding-top: 30px;
                }
            }
            .wrapper {
                position: relative;
                background-color: #010101;
                border-radius: size(6);
                @media screen and (max-width: $breakpoint-md) {
                    padding: 0;
                }
                @media screen and (min-width: 425px) {
                    background-color: #010101;
                }
                .flag-text {
                    clip-path: none;
                    background: none;
                    width: auto;
                    margin: 0 0 size(10);
                    padding: 0;
                    color: #D0F37B;
                    font-size: size(16);
                    font-weight: 700;
                    line-height: normal;
                    text-transform: capitalize;
                    display: inline-block;
                    @media screen and (min-width: size(1024)) {
                        font-size: size(24);
                    }
                }
                .hero-title {
                    display: block;
                    .p {
                        color: var(--rs-white-color);
                        font-size: size(20);
                        line-height: size(28);
                        @media screen and (min-width: $breakpoint-lg) {
                            font-size: size(40);
                            line-height: size(50);
                        }
                    }
                }
                .text-button.rs-button .link {
                    padding: 0;
                    margin: 0;
                    color: var(--rs-white-color);
                    border: none;
                    outline: none;

                    &:after {
                        border-color: var(--rs-white-color);
                        margin-left: size(10);
                    }
                }
                .image-wrapper {
                    @media screen and (min-width: $breakpoint-md) {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        height: size(365);
                        padding-left: 0;
                        height: 100%;
                    }
                    @media screen and (min-width: size(1024)) {
                        height: size(300);
                    }
                    @media screen and (min-width: $breakpoint-md) {
                        height: 100%;
                    }
                    @media screen and (max-width: 425px) {
                        padding-bottom: 20px;
                    }
                    .banner-artwork {
                        width: 98%;
                        @media screen and (min-width: size(1024)) {
                            width: size(600);
                        }
                        @media screen and (min-width: $breakpoint-lg) {
                            width: size(464);
                        }
                        @media screen and (max-width: 425px) {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
}
.ants-promo {
   &.promo {
    .rs-container {
        padding-top: size(32);
        @media screen and (min-width: $breakpoint-md) {
            padding-bottom: 0;
        }
      .wrapper {
        position: relative;
        background-color: #010101;
        border-radius: size(6);
        padding: size(30) size(20);
        @media screen and (min-width: $breakpoint-md) {
            padding: size(40) size(20);
        }
        @media screen and (min-width: $breakpoint-lg) {
            padding: size(60);
        }
        .flag-text {
            clip-path: none;
            background: none;
            width: auto;
            margin: 0 0 size(10);
            padding: 0;
            color: #D0F37B;
            font-size: size(16);
            font-weight: 700;
            line-height: normal;
            text-transform: capitalize;
            display: inline-block;
            @media screen and (min-width: size(1024)) {
                font-size: size(24);
            }
        }
        .hero-title {
            display: block;
            .p {
                color: var(--rs-white-color);
                font-size: size(20);
                line-height: size(28);
                @media screen and (min-width: $breakpoint-lg) {
                    font-size: size(40);
                    line-height: size(50);
                }
            }
        }
        .text-button.rs-button .link {
            padding: 0;
            margin: 0;
            color: var(--rs-white-color);
            border: none;
            outline: none;
            &:after {
                border-color: var(--rs-white-color);
                margin-left: size(10);
            }
        }
        .image-wrapper {
            @media screen and (min-width: $breakpoint-md) {
                position: absolute;
                right: 0;
                bottom: 0;
                height: size(365);
                padding-left: 0;
                height: 100%;
            }
            @media screen and (min-width: size(1024)) {
                height: size(300);
            }
            @media screen and (min-width: $breakpoint-md) {
                height: 100%;
            }

            .banner-artwork {
                width: 98%;
                @media screen and (min-width: size(1024)) {
                    width: size(600);
                }
                @media screen and (min-width: $breakpoint-lg) {
                    width: size(464);
                }
            }
        }
      }
    }
  }
}
.widget-banner {
   &.promo {
    .rs-container {
        padding-top: size(32);
        @media screen and (min-width: $breakpoint-md) {
            padding-bottom: 0;
        }
      .wrapper {
        position: relative;
        overflow: hidden;
        background-color: #121212;
        background-image: url('../../assets/backgroung.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: size(6);
        padding: size(30) size(20);
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $breakpoint-md) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: size(40) size(20);
        }
        @media screen and (min-width: $breakpoint-lg) {
            padding: size(50) size(60);
        }
        .flag-text {
            clip-path: none;
            background: linear-gradient(107deg, #8BECB5 19.68%, #F5FF78 103.18%);
            width: auto;
            margin: 0 0 size(16);
            padding: size(3.576) size(7.153);
            color: #010101;
            font-size: size(12);
            font-weight: 700;
            line-height: normal;
            text-transform: capitalize;
            display: inline-block;
            border-radius: size(3.576);
        }
        .hero-title {
            display: block;
            max-width: size(487);
            margin-bottom: size(0);
            padding-bottom: size(12);
            .p {
                color: #FFF;
                font-size: size(24);
                font-weight: 800;
                line-height: size(30);
                @media screen and (min-width: $breakpoint-md) {
                    font-size: size(32);
                    line-height: size(38);
                }
                @media screen and (min-width: $breakpoint-lg) {
                    font-size: size(40);
                    line-height: size(46);
                }
            }
        }
        .text {
            margin-bottom: size(20);
            .p {
                color: #FFF;
                font-size: size(14);
                padding-bottom: size(32);
                font-weight: 400;
                line-height: 160%;
                @media screen and (min-width: $breakpoint-md) {
                    font-size: size(16);
                }
            }
        }
        .text-button.rs-button .link {
            padding: 0;
            margin: 0;
            color: #FFF385;
            font-size: size(15);
            font-weight: 700;
            line-height: 110%;
            border: none;
            outline: none;
            &:after {
                border-color: #FFF385;
                margin-left: size(10);
            }
        }
        .image-wrapper {
            text-align: center;
            height :100%;
            padding-top: size(20);
            @media screen and (min-width: $breakpoint-md) {
                position: absolute;
                right: size(20);
                top: 20%;
                padding-top: 0;
                padding-left: 0;
                text-align: right;
            }
            @media screen and (min-width: $breakpoint-lg) {
                right: size(60);
            }

            .banner-artwork {
                max-width: 100%;
                width: size(260);
                height: size(260);
                object-fit: contain;
                @media screen and (min-width: $breakpoint-md) {
                    width: size(320);
                    height: size(293);
                }
                @media screen and (min-width: size(1024)) {
                    width: size(360);
                    height: size(330);
                }
                @media screen and (min-width: $breakpoint-lg) {
                    width: size(390);
                    height: size(357);
                }
            }
        }
      }
    }
  }
}
.ipl-2026-api {
    &.promo {
        .rs-container {
            padding-top: size(32);
            padding-bottom: size(0);
            @media screen and (min-width: $breakpoint-md) {
                padding-bottom: 0;
            }

            .banner-wrapper {
                padding: 0%;

                @media screen and (max-width: $breakpoint-md) {
                    padding: 0;
                }
            }

            .wrapper {
                background-color: #ECE9FF;
                display: flex;
                padding: 0;
                flex-direction: column;

                .content-wrapper {
                    padding-left: size(20);
                    padding-right: size(20);
                    padding-top: size(20);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    padding-bottom: 0;

                    .flag-text {
                        background: transparent;
                        width: 100%;
                        clip-path: none;
                        font-size: size(14);
                        font-weight: 500;
                        padding: 0;
                        text-transform: capitalize;
                        display: flex;
                        gap: size(4);
                        margin-bottom: size(16);
                        margin-top: 0;
                        align-items: center;

                        &::before {
                            content: url('../../assets/ipl-2025-icon.svg');
                            display: block;
                            margin-top: size(4);
                        }
                    }

                    .hero-title {
                        background: url('../../assets/ipl2026.svg') no-repeat;
                        background-size: contain;
                        max-width: 100%;
                        color: transparent;
                        height: size(50);
                        background-size: 50%;
                        width: 100%;
                        margin: 0;
                    }

                    .markdown {
                        margin: 0;
                        padding-bottom: size(10);
                    }

                    .text {
                        .p {
                            font-size: size(16);
                            font-weight: 400;
                            color:var(--rs-black-color);
                        }
                    }

                    .text-button {
                        span {
                            font-size: size(12);
                            font-weight: 500;
                        }

                        background: var(--rs-black-color);
                        border-radius: size(4);
                        padding: size(16);
                        display: inline-block;
                    }
                }

                .image-wrapper {
                    display: block;
                    padding: size(30) 0;
                    height: size(220);
                }
            }

            @media screen and (min-width: $breakpoint-md) {
                .wrapper {
                    aspect-ratio: 1080 / 447;
                    background-image: url('../../assets/IPL-2026.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    height: auto;
                    padding: 0;

                    .image-wrapper {
                        display: none;
                    }

                    .content-wrapper {
                        height: auto;
                        margin-top: size(30);
                        margin-left: size(40);
                        padding-top: size(0);
                        width: 50%;
                        max-width: size(600);
                        .markdown {
                            padding-bottom: 0;
                        }

                        .hero-title {
                            height: size(60);
                        }

                        .text {
                            .p {
                                font-size: size(12);
                                font-weight: 400;
                                color: var(--rs-black-color);
                                padding-bottom: size(12);
                            }
                        }

                        .markdown {
                            padding-bottom: size(10);
                        }

                        .image-wrapper {
                            display: none;
                        }

                        .text-button {
                            span {
                                font-size: size(12);
                                font-weight: 500;
                            }

                            background: var(--rs-black-color);
                            border-radius: size(4);
                            padding: size(12);
                            display: inline-block;
                        }
                    }
                }
            }

            @media screen and (min-width: size(1024)) {
                .wrapper {
                    height: size(447);

                    .content-wrapper {
                        height: size(310);
                        margin-top: size(46);
                        margin-left: size(52);
                        width: size(560);
                        max-width: none;
                        .markdown {
                            padding-bottom: 0;
                        }

                        .hero-title {
                            height: size(92);
                        }

                        .text .p {
                            font-size: size(16);
                            font-weight: 400;
                            color: var(--rs-black-color);
                            padding-bottom: 0;
                        }
                        .text-button {
                              margin-top: size(40);
                        }
                    }
                }
            }
        }
    }
}
.icc-2026-promo-banner {
  &.promo {
    .rs-container {
      padding-top: size(32);

      @media screen and (min-width: $breakpoint-md) {
        padding-bottom: 0;
      }
      .wrapper {
        padding-top: size(10);
        padding-bottom: 0;
        background-color: #020438;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
                .image-wrapper{
                    padding: size(30) 0;
                    img{
                        width:100%;
                        @media screen and (min-width: $breakpoint-md) {
                            width: 76%;
                        }
                        @media screen and (min-width: $breakpoint-lg) {
                            width: size(340);
                        }
                    }
                    height: size(150);
                    @media screen and (min-width: $breakpoint-md) {
                        padding: 0;
                        height: size(450);
                    }
                }
                .content-wrapper {
                    height: auto;
                    @media screen and (min-width: $breakpoint-md) {
                        padding-bottom: size(22);
                    }
                    .flag-text {
                        background-color: transparent;
                        width: 100%;
                        font-size: size(16);
                        font-weight: 600;
                        margin-bottom: 0;
                        text-transform: capitalize;
                        padding: 0;
                        clip-path: none;
                    }

                    .hero-title {
                        color: var(--rs-white-color);
                        font-size: size(20);
                        font-style: normal;
                        font-weight: 800;
                        line-height: size(28);
                        margin: size(16) 0;
                        padding: 0;
                        @media  screen and (min-width: $breakpoint-md) {
                            font-size: size(38);
                            font-weight: 800;
                            line-height: size(50);
                        }
                    }
                    p, span.p {
                            max-width: size(440);
                        }
                    .text {
                        .p {
                            strong {
                                font-weight: 600;
                            }
                        }

                    }
                }
        @media screen and (min-width: $breakpoint-md) {
            padding-top: 0;
            flex-direction: row;
            background-image:
                url('../../assets/icc-2024-bg1.svg'),
                url('../../assets/icc-2024-bg2.svg'),
                url('../../assets/icc-2024-bg3.svg');

            background-position:
                top -180px right -120px,
                bottom -490px right 120px,
                bottom -120px right -120px;

            background-repeat: no-repeat;
          .hero-title{
            font-size: size(28);
          }
        }
        @media screen and (min-width: $breakpoint-lg) {
          background-position:
            top -180px right -120px,
            bottom -490px right 120px,
            bottom -142px right -120px;
        }
      }
    }
  }
}

</style>
<style lang="scss" scoped>
.banner-wrapper {
    background: #2D2F9D;
    border-radius: size(6);
    padding: size(30) size(20) 0;
    @media screen and (min-width: $breakpoint-md) {
        padding: size(30) size(20) size(50);
    }
    @media screen and (min-width: size(1024)) {
        padding-bottom: 0;
    }
    @media screen and (min-width: $breakpoint-lg) {
        padding: size(40) size(60);
    }
    .content-wrapper {
        display: inline-block;
        vertical-align: top;
        @media screen and (min-width: $breakpoint-md) {
            width: 50%;
        }
        @media screen and (min-width: $breakpoint-lg) {
            width: size(490);
        }
        .text-img {
            display: inline-block;
            width: size(98);
            padding-bottom: size(10);
            padding-top: size(20);
        }
        h6 {
            font-size: size(14);
            line-height: size(20);
            color: var(--rs-white-color);
            margin-bottom: size(10);
            margin-top: size(20);
            &.flag-text {
                clip-path: polygon(0% 0%, 100% 0%, 90% 50%, 100% 100%, 0% 100%);
                background: #97E6AB;
                text-transform: uppercase;
                -webkit-clip-path: polygon(0% 0%, 100% 0%, 90% 50%, 100% 100%, 0% 100%);
                width: size(73);
                font-size: size(10);
                line-height: size(14);
                font-weight: 600;
                color: black;
                padding: size(3) size(16) size(3) size(9);
            }
        }
    }
    .image-wrapper {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        padding-top: size(30);
        width: 100%;
        height: size(350);
        @media screen and (min-width: $breakpoint-md) {
            padding-left: size(30);
            width: 45%;
            padding-top: size(75);
            height: size(400);
        }
        @media screen and (min-width: size(1024)) {
            padding-top: 0;
        }
        @media screen and (min-width: $breakpoint-lg) {
            padding-left: size(50);
            width: auto;
        }
        .banner-artwork {
            display: inline-block;
            vertical-align: bottom;
            @media screen and (min-width: $breakpoint-md) {
                width: 100%;
            }
            @media screen and (min-width: $breakpoint-lg) {
                width: size(420);
            }
        }
    }
}
.broadcast-overlay-promo {
    &.promo .rs-container {
        padding-top: size(32);
        padding-bottom: 0;
    }
    .wrapper {
        background-color: #010101;
        border-radius: size(6);
        display: flex;
        flex-direction: column;
        padding: size(30) size(20);
        overflow: hidden;
        @media screen and (min-width: $breakpoint-md) {
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            padding: size(40) size(20);
        }
        @media screen and (min-width: $breakpoint-lg) {
            padding: size(60) size(60);
        }
    }
    .content-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: $breakpoint-md) {
            width: 55%;
            padding-right: size(20);
        }
        @media screen and (min-width: size(1024)) {
            width: size(440);
            padding-right: size(40);
            padding-top: 0;
        }
    }
    .badge {
        display: inline-block;
        background: linear-gradient(107deg, #8BECB5 19.68%, #F5FF78 103.18%);
        color: #010101;
        font-size: size(12);
        font-weight: 700;
        padding: size(4) size(10);
        border-radius: size(4);
        margin-bottom: size(16);
    }
    .title {
        color: var(--rs-white-color);
        font-size: size(28);
        font-weight: 800;
        line-height: 1.1;
        margin: 0 0 size(12);
        @media screen and (min-width: $breakpoint-md) {
            font-size: size(32);
            width: size(400);
        }
        @media screen and (min-width: $breakpoint-lg) {
            font-size: size(40);
        }
    }
    .desc {
        color: #FFF;
        font-size: size(16);
        font-weight: 400;
        line-height: 160%;
        margin: 0 0 size(32);
    }
    .cta-link {
        color: #FFF385;
        font-size: size(15);
        font-weight: 700;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: size(8);
        &::after {
            content: '';
            display: inline-block;
            width: size(8);
            height: size(8);
            border-right: 2px solid #FFF385;
            border-top: 2px solid #FFF385;
            transform: rotate(45deg);
        }
    }
    .image-wrapper {
        display: flex;
        justify-content: center;
        margin-top: size(30);
        @media screen and (min-width: $breakpoint-md) {
            margin-top: 0;
            width: 40%;
            height: auto;
            padding-left: 0;
            padding-top: 0;
            justify-content: flex-end;
        }
        @media screen and (min-width: size(1024)) {
            flex: 1;
        }
        .overlay-img {
            width: 100%;
            max-width: size(300);
            height: auto;
            object-fit: contain;
            border-radius: size(8);
            @media screen and (min-width: $breakpoint-md) {
                max-width: 100%;
            }
            @media screen and (min-width: size(1024)) {
                width: 70%;
                max-width: size(440);
            }
        }
    }
}
</style>
